import React, { FunctionComponent } from 'react';
import { Card, Paragraph, Heading, Divider } from '@mlc/web-ui-toolkit';
import { chevronDown, chevronUp } from '@mlc/symbols';
import { Employer } from '../../../../logic/domains/planProfile.domain';
import { isMobile } from '../../../../screens';
import { ResponsiveAccordion } from './styled';
import planProfileTestIds from './PlanProfile.elements';

type Props = {
	employerDetails: Employer;
};

const EmployerDetails: FunctionComponent<Props> = ({ employerDetails }) => {
	return (
		<>
			<ResponsiveAccordion
				el="h3"
				title={<Title />}
				isOpen={isMobile ? false : true}
				onChange={isMobile ? null : () => {}}
				openSymbol={chevronDown}
				closeSymbol={chevronUp}
				noBorder={true}
			>
				<Card borderColor="mlcDove" border="mlcBorderThin" />
				<Card margin={2} marginBottom={4} marginTop={4}>
					<Item
						label="Employer"
						value={employerDetails.name}
						id={planProfileTestIds.employerName}
					/>
					<Item
						label="Contact"
						value={employerDetails.contact}
						id={planProfileTestIds.employerContact}
					/>
					<Item
						label="Title"
						value={employerDetails.title}
						id={planProfileTestIds.employerTitle}
					/>
					<Separator />
					<Item
						label="Phone"
						value={employerDetails.phone}
						id={planProfileTestIds.employerPhone}
					/>
					<Item
						label="Fax"
						value={employerDetails.fax}
						id={planProfileTestIds.employerFax}
					/>
					<Item
						label="Email"
						value={employerDetails.email}
						id={planProfileTestIds.employerEmail}
					/>
					<Separator />
					<Items
						label="Street address"
						values={employerDetails.address}
						id={planProfileTestIds.employerAddress}
					/>
				</Card>
			</ResponsiveAccordion>
		</>
	);
};

const Title = () => (
	<Heading el="h3" fontWeight="medium" fontSize="little">
		Employer Details
	</Heading>
);

const Items = ({
	label,
	values,
	id,
}: {
	label: string;
	values: string[];
	id?: string;
}) => (
	<>
		{values.length > 0 ? (
			<>
				<ItemLabel label={label} />
				{values.map((value, idx) => (
					<ItemValue key={idx} value={value} id={`${id}-${idx}`} />
				))}
			</>
		) : (
			<Item label={label} id={id} />
		)}
	</>
);

const Item = ({
	label,
	value,
	id,
}: {
	label: string;
	value?: string;
	id?: string;
}) => (
	<>
		<ItemLabel label={label} />
		<ItemValue value={value} id={id} />
	</>
);

const ItemLabel = ({ label }: { label: string }) => (
	<Paragraph
		marginTop={4}
		marginBottom={1}
		fontSize="disclaimer"
		fontWeight="regular"
		color="mlcVeryDarkGrey"
	>
		{label}
	</Paragraph>
);

const ItemValue = ({ value, id }: { value?: string; id?: string }) => (
	<Paragraph
		margin={0}
		fontSize="standard"
		fontWeight="semibold"
		color="mlcVeryDarkGrey"
		style={{ wordBreak: 'break-word' }}
		data-id={id}
	>
		{value ? value : 'Not supplied'}
	</Paragraph>
);

const Separator = () => <Divider marginTop={4} marginBottom={4} />;

export default EmployerDetails;
